export default "__VITE_ASSET__BX_fx9cc__"